// extracted by mini-css-extract-plugin
export default {"popover_content":"style_popover_content__R-cJn"};